<template>
<div class="logistics-container">
    <!-- 左侧物流基本信息 -->
    <div class="logistics-base-info">
      <img 
        src="../assets/images/logistics-tracking.png" 
        alt="物流图标" 
        class="logistics-icon"
      >
      <div class="info-text">
        <h3>物流信息</h3>
        <p>物流公司: {{ logistics_name }}</p>
        <p>快递单号: {{ logistics_no }}</p>
      </div>
    </div>

    <!-- 右侧物流轨迹时间轴 -->
    <div class="logistics-timeline">
      <div 
        v-for="(item, index) in trackingList" 
        :key="index" 
        class="timeline-item"
        :class="{ active: index === 0 }"
      >
       <div class="timeline-time">{{ item.opTime }}</div>
        <!-- 时间轴节点 -->
        <div class="timeline-dot">
          <div class="dot-inner"></div>
          <div v-if="index < trackingList.length - 1" class="timeline-line"></div>
        </div>
        
        <!-- 物流信息内容 -->
        <div class="timeline-content">
         
          <div class="timeline-status" v-if="item.opDesc">{{ item.opDesc }}</div>
          <div class="timeline-desc">{{ item.opMessage }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "LogisticsTracking",
  components: {},
  props: {
        logistics_name: {
            type: String,
            default: ''
        },
        logistics_no: {
            type: String,
            default: ''
        },
        trackingList:{
            type: Array,
        }
    },
  data() {
    return {
      
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.logistics-container {
  display: flex;
  margin: 0 auto;
  font-family: "Microsoft Yahei", sans-serif;
  height: 400px;
  background: #F9FAFC;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 20px;
}
.logistics-container::-webkit-scrollbar {
  display: none;
}

/* 左侧基础信息 */
.logistics-base-info {

  width: 250px;
  margin-right: 170px;
}

.logistics-icon {
  width: 230px;
  height: 130px;
  margin-right: 15px;
}

.info-text h3 {
  font-size: 18px;
  margin: 0 0 10px 0;
  color: #333;
}

.info-text p {
  font-size: 13px;
  color: #191A1C;
  margin: 5px 0;
}

/* 右侧时间轴 */
.logistics-timeline {
  flex: 1;
}

.timeline-item {
  display: flex;
  margin-bottom: 20px;
  position: relative;
}

/* 时间轴节点和线条 */
.timeline-dot {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}

.dot-inner {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #ccc;
  z-index: 1;
}

.timeline-line {
  width: 2px;
  height: 100%;
  background-color: #C9C9C9;
//   margin-top: 5px;
  margin-bottom: -20px;
  flex: 1;
}

/* 激活状态（当前物流节点） */
.timeline-item.active .dot-inner {
  background-color: #FA3D5A; /* 顺丰红 */
}

.timeline-item.active .timeline-status {
  color: #FA3D5A;
  font-weight: bold;
}

/* 物流内容 */
.timeline-content {
  flex: 1;
}

.timeline-time {
  font-size: 14px;
  color: #666666;
  margin-right: 20px;
}

.timeline-status {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
  margin-top: -2px;
}

.timeline-desc {
  font-size: 14px;
  color: #8C8C8C;
  line-height: 1.5;
}
</style>
